export const hasActiveLogFilters = (filters: object) =>
  Object.values(filters).some((value) => value !== undefined && value !== null)
